// React
import React from "react";

// Packages
import Typography from '@mui/material/Typography';

const Maintenance = () => {
  return (
    <>
      <Typography variant="h3" gutterBottom>En mantenimiento</Typography>
    </>
  );
};

export default Maintenance;
